// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1RJn4","file":"styles_file__evKX4"};